/**
 *
 * @param {HTMLButtonElement} e
 */
const onClickTab = (e) => {
	const buttons = document.querySelectorAll(".product-columns__heading-btn");
	const buttonActive = Array.from(buttons).find((btn) =>
		btn.classList.contains("active")
	);
	buttonActive.classList.remove("active");
	e.classList.add("active");

	const contents = document.querySelectorAll(".product-columns__body-text");
	const contentActive = Array.from(contents).find((el) =>
		el.classList.contains("active")
	);
	contentActive.classList.remove("active");

	const contentContaier = document.querySelector(".product-columns__body");
	
	switch (e.id) {
		case "descriptionButton":
			document.getElementById("descriptionText").classList.add("active");
			contentContaier?.setAttribute("data-active-tab", "description");
			break;

		case "informationButton":
			document.getElementById("informationText").classList.add("active");
			contentContaier?.setAttribute("data-active-tab", "information");
			break;

		case "customMessageButton":
			document.getElementById("customMessageText").classList.add("active");
			contentContaier?.setAttribute("data-active-tab", "custom-message");
			break;

		default:
			break;
	}
};